export default function PIFScoreCard({ submission, rubric }) {
  if (!submission) {
    return (
      <div className="card" style={{ padding: 16 }}>
        <p className="text-muted" style={{ fontSize: 13 }}>No PIF submission yet.</p>
      </div>
    );
  }

  const { raw_score, normalised_score, meets_threshold } = submission;
  const threshold = rubric?.advancement_threshold;
  const normFactor = rubric?.normalisation_factor;

  return (
    <div style={{
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius)',
      padding: '14px 16px',
      background: 'var(--color-card)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
        <div>
          <p style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--color-text-secondary)', marginBottom: 4 }}>PIF Score</p>
          <p style={{ fontSize: 28, fontWeight: 700, color: meets_threshold ? 'var(--color-success)' : 'var(--color-error)', lineHeight: 1 }}>
            {normalised_score?.toFixed(2)}
          </p>
          {(raw_score != null || normalised_score != null) && (
            <p style={{ fontSize: 11, color: 'var(--color-text-secondary)' }}>
              Raw: {(raw_score ?? Math.round((normalised_score / (normFactor || 10)) * (submission.max_possible_sum || normFactor || 10) * 100) / 100)?.toFixed(2)} / {submission.max_possible_sum || normFactor || 10}
            </p>
          )}
        </div>
        <span style={{
          padding: '4px 10px',
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 600,
          background: meets_threshold ? 'var(--color-success-bg)' : 'var(--color-error-bg)',
          color: meets_threshold ? 'var(--color-success)' : 'var(--color-error)',
          border: `1px solid ${meets_threshold ? '#86efac' : '#fca5a5'}`,
        }}>
          {meets_threshold ? '✓ Meets Threshold' : '✗ Below Threshold'}
        </span>
      </div>
      {threshold != null && (
        <div style={{ height: 8, background: 'var(--color-border)', borderRadius: 4, overflow: 'hidden' }}>
          <div style={{
            height: '100%',
            width: `${Math.min(100, (normalised_score / (threshold * 1.5)) * 100)}%`,
            background: meets_threshold ? 'var(--color-success)' : 'var(--color-error)',
            borderRadius: 4,
            transition: 'width 0.4s',
          }} />
        </div>
      )}
      {threshold != null && (
        <p style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 4 }}>
          Threshold: {threshold}
        </p>
      )}
    </div>
  );
}
